import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class PortfolioCard extends Component {

	constructor(props){

       super(props);

    }



	render(){

		return (
			<div className="card" onClick={() => window.scrollTo(0, 0)}>

        <Link to={'/portfolio/' + this.props.slug}><div className="image"><img src={this.props.image} /></div></Link>

			</div>
		);

	}

}


export default PortfolioCard



// WEBPACK FOOTER //
// ./src/Components/PortfolioCard.js